module.exports = __webpack_public_path__ + "media/images/favicon-62f26481fd100fefae577dacb36f8fb6.png";